export enum BalanceType {
    CREDIT = 'CREDIT',
    DEBIT = 'DEBIT'
}

export enum DifferenceType {
    POSITIVE = 'POSITIVE',
    NEGATIVE = 'NEGATIVE'
}

export class DashboardKpiItem {
    position?: number;
    record_id?: number;
    record_name?: string;
    record_description?: string;
    record_currency_code?: string;
    transaction_entity_name?: string;
    transaction_entity_category?: string;
    transaction_entity_type?: string;
    balance_amount?: number;
    balance_type?: BalanceType;
    difference_percentage?: number;
    difference_type?: DifferenceType;
    difference?: number;

    constructor(init?: Partial<DashboardKpiItem>) {
        Object.assign(this, init);
    }

    /**
     * Creates a DashboardKpiItem from a JSON object
     */
    static fromJSON(json: any): DashboardKpiItem {
        return new DashboardKpiItem({
            position: json.position,
            record_id: json.record?.id,
            record_name: json.record?.record_name,
            record_description: json.record?.record_description,
            record_currency_code: json.record?.record_currency_code,
            transaction_entity_name: json.transaction_entity?.transaction_entity_name,
            transaction_entity_category: json.transaction_entity?.transaction_entity_category,
            transaction_entity_type: json.transaction_entity?.transaction_entity_type,
            balance_amount: json.balance_amount,
            balance_type: json.balance_type === 'credit' ? BalanceType.CREDIT : BalanceType.DEBIT,
            difference_percentage: json.difference_percentage,
            difference_type: json.difference_type === 'positive' ? DifferenceType.POSITIVE : DifferenceType.NEGATIVE,
            difference: json.difference
        });
    }
}